import { getBundleResourceTranslation } from "./CESRequest";

export const translate = (key: string, warnMissing: boolean = true) => {
    try {
        return getBundleResourceTranslation(key, warnMissing);
    } catch {
        return "";
    }
}

export const debounce = (callback: (...args: unknown[]) => void, wait = 300) => {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  return (...args: unknown[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => callback(...args), wait);
  };
}
